module.exports = __webpack_public_path__ + "66462a57630af2de33bc3e669878657a.svg";